<template>
  <div class="base-bottom-sheet-list-card">
    <v-bottom-sheet
      v-model="internOpen"
      scrollable
      :retain-focus="false"
      overlay-color="grey-darken-4"
      :overlay-opacity="0.6"
      content-class="elevation-0"
    >
      <template #activator="{ on }">
        <slot name="activator" :on="on"> </slot>
      </template>
      <v-card
        flat
        tile
        elevation="0"
        color="transparent"
        class="base-bottom-sheet-list-card__card"
      >
        <slot name="top"></slot>
        <v-card-title class="py-0 px-4 white" style="height: 44px">
          <span class="text-body-3">{{ title }}</span>
          <v-spacer></v-spacer>
          <base-button icon small @click="internOpen = false">
            <base-icon mdi="close" small></base-icon>
          </base-button>
        </v-card-title>
        <base-divider></base-divider>
        <v-card-text class="pa-0 white" style="height: 300px">
          <v-list dense color="white">
            <v-list-item-group v-model="internalValue" mandatory>
              <v-list-item
                v-for="item in items"
                :key="item.value"
                :value="item.value"
                @click="internOpen = false"
              >
                <slot name="item" v-bind="item">
                  <v-list-item-content class="text-body-3">
                    {{ item.text }}
                  </v-list-item-content>
                </slot>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
import BaseIcon from '~/components/base/icon/BaseIcon'
import BaseDivider from '~/components/base/divider/BaseDivider'
import BaseButton from '~/components/base/button/BaseButton'

export default {
  name: 'BaseBottomSheetListCard',
  components: { BaseButton, BaseDivider, BaseIcon },
  props: {
    value: {
      type: String,
      default: undefined,
    },
    items: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internOpen: this.open,
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {
    open(newValue) {
      this.internOpen = newValue
    },
    internOpen(newValue) {
      this.$emit('change:open', newValue)
    },
  },
}
</script>
<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.base-bottom-sheet-list-card {
  .v-card--link:focus:before {
    opacity: 0;
  }

  &__card {
    .v-list-item--active {
      background-color: map-get($shades, 'grey-lighten-4');

      &::before {
        opacity: 0;
      }
    }
  }
}
</style>
